/**
 * Función que se encarga de realizar el arry para los filtros
 * Alexander Arenas -2023-03-13
 */

export function validarStringMultiple(id) {
      if (id != null) {
            let data = '(';
            for (let i = 0; i < id.length; i++) {
                  data = data + "'" + id[i] + "'";
                  if (id.length - 1 != i) {
                        data = data + ',';
                  }
            }
            data = data + ')';
            return data;
      }
}


// WEBPACK FOOTER //
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/utilidades/funciones.ts